import * as vp from 'vopay';
import * as Yup from 'yup';
import { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Formik } from 'formik';
import { RetriggerWebhookDialogueHandler } from './types';
import { buildRetriggerWebhookDialogueRows } from './buildRetriggerWebhookDialogueRows.helper';
const { Button, Table, TextField } = vp;
type RetriggerWebhookDialogueFormProps = {
  defaultValues: vp.RetriggerWebhookRequest;
  variant: 'webhook-retrigger';
  handlers: RetriggerWebhookDialogueHandler;
  closeModal: () => void;
  webhookEventType: { id: string; label: string };
};

type FC = FunctionComponent<RetriggerWebhookDialogueFormProps>;

const RetriggerWebhookDialogueForm: FC = (props: RetriggerWebhookDialogueFormProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'RetriggerWebhookDialogueForm' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { defaultValues, variant, handlers, closeModal, webhookEventType } = props;
  const retriggerWebhookDialogueRows = buildRetriggerWebhookDialogueRows(variant);
  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={handlers.retriggerWebhook}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ values, setValues, handleChange, handleBlur, submitForm, resetForm }) => {
        useEffect(() => {
          setValues({ ...values, Type: webhookEventType.id });
        }, [webhookEventType]);

        const paylinkSettingsTable: vp.TableProps = {
          name: 'retrigger-webhook-fields',
          variant: 'pair',
          columns: {
            Input: { header: t('fieldsColumnHeader', { defaultValue: 'Fields' }) },
          },
          rows: retriggerWebhookDialogueRows.map(({ id, preset, type, isVisible }) => ({
            Input: (
              <>
                {type === 'input' && (
                  <TextField
                    preset={preset}
                    key={id}
                    name={id}
                    variant="outlined"
                    placeholder={t('webhookIdPlaceholder', { defaultValue: 'Webhook ID' })}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values[id] as string}
                    error={null}
                    isVisible={isVisible}
                  />
                )}
              </>
            ),
          })),
        };
        return (
          <form>
            <Table {...paylinkSettingsTable} />
            <div
              style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', gap: '20px', padding: '1em' }}
            >
              <Button
                id="AddLabel-Accept"
                label={tGlobal('Buttons.cancel')}
                color="secondary"
                type="button"
                onClick={() => {
                  closeModal(), resetForm();
                }}
              />

              <Button
                id="AddLabel-Accept"
                label={t('retriggerWebhook', { defaultValue: 'Retrigger Webhook' })}
                color="primary"
                onClick={() => {
                  submitForm();
                }}
                isDisabled={values.EventID === '' || values.EventID === undefined}
                type="button"
              />
            </div>
          </form>
        );
      }}
    </Formik>
  );

  function createdValidationSchema() {
    return Yup.object().shape({
      EventID: Yup.string().required(t('validWebhookIdRequired', { defaultValue: 'Please enter a valid webhook ID.' })),
    });
  }
};

export default RetriggerWebhookDialogueForm;
